import './PredictionPopUp.scss';
import React, { useEffect, useState } from "react";
import WeatherConditions from '../../WeatherConditions';
import predictionIcon from '../../../assets/icons/alert-png.png';
import calendar from '../../../assets/icons/calendar-icon.png';
import location from '../../../assets/icons/location-icon.png';
import globe from '../../../assets/icons/globe-icon.png';
import left from '../../../assets/icons/left.png';
import moment from 'moment-timezone';
import RiskComponent from '../../RiskComponent';
import Comments from '../../Comments';

export default function PredictionPopUp(props) {
    const { 
        setPanel, 
        user,
        setUser,
        prediction
    } = props;

    const [tab, setTab] = useState('Details');

    useEffect(() => {
        setTab('Details');
    }, [prediction]);

    const formatDate = (timestamp) => {
        const time = moment.utc(timestamp).local();
        return time.format('YYYY-MM-DD hh:mm:ss A');
    }

    const formatDecimal = (decimal) => {
        let [integerPart, decimalPart] = decimal.toString().split('.');
    
        if (!decimalPart) {
            decimalPart = '0000000';
        } else if (decimalPart.length < 7) {
            decimalPart = decimalPart.padEnd(7, '0');
        }
    
        decimalPart = decimalPart.slice(0, 6) + '1';
    
        return parseFloat(`${integerPart}.${decimalPart}`);
    }


    const stageSwitch = (stage) => {
        switch (stage) {
            case 'Details':
                return (
                    <div className='prediction-popup-details'>
                        <div className='prediction-popup-details-fields'>
                            <div className='prediction-popup-details-fields-left'>
                                <div className='prediction-popup-details-fields-left-field'>
                                    <div className='prediction-popup-details-fields-left-field-value'>Temperature Minimum</div>
                                    <div className='prediction-popup-details-fields-left-field-title'>{prediction.temperature_min ? `${((prediction.temperature_min * (9/5)) + 32).toFixed(0)}° F ` : 'Not Available'}</div>
                                </div>
                                <div className='prediction-popup-details-fields-left-field'>
                                    <div className='prediction-popup-details-fields-left-field-value'>Temperature maximum</div>
                                    <div className='prediction-popup-details-fields-left-field-title'>{prediction.temperature_max ? `${((prediction.temperature_max * (9/5)) + 32).toFixed(0)}° F ` : 'Not Available'}</div>
                                </div>
                            </div>
                            <div className='prediction-popup-details-fields-right'>
                                <div className='prediction-popup-details-fields-right-field'>
                                    <div className='prediction-popup-details-fields-right-field-value'>Cause</div>
                                    <div className='prediction-popup-details-fields-right-field-title'>UNDETERMINED</div>
                                </div>
                                <div className='prediction-popup-details-fields-right-field'>
                                    <div className='prediction-popup-details-fields-right-field-value'>Humidity</div>                               
                                    <div className='prediction-popup-details-fields-right-field-title'>{prediction.humidity ? `${prediction.humidity}%`: 'Not Available'}</div>
                                </div>
                            </div>
                        </div>
                        <WeatherConditions coordinates={[prediction.latitude, prediction.longitude]}/>
                    </div>
                )
            case 'Risk':
                return (
                    <RiskComponent 
                        user={user} 
                        setUser={setUser} 
                        coordinates={[formatDecimal(prediction.longitude), formatDecimal(prediction.latitude)]}
                    />
                )
            case 'Comments':
                return (
                    <Comments 
                        user={user} 
                        setUser={setUser}
                        id={prediction.fire_id.toString()}
                    />
                )
        }
    }

    return (
        prediction ?
        <div className='prediction-popup'>
            <div className='prediction-popup-back-btn' 
                onClick={() => {
                    setPanel({
                        name: 'Predictions', 
                        content: null
                    });
                }}
            >
                <img 
                    src={left} 
                    className="prediction-popup-back-btn-icon"
                />
                Back to results
            </div>
            <div className='prediction-popup-header'>
                <div className='prediction-popup-header-title'>
                    <img src={predictionIcon} className='prediction-popup-header-title-icon'/>
                    <div className='prediction-popup-header-title-text'>Wildifire Prediction ({prediction.fire_id})</div>
                </div>
            </div>
            <div className="prediction-popup-main">
                <div className="prediction-popup-main-left">
                    <div className="prediction-popup-main-left-country">
                        <img src={globe} className="prediction-popup-main-left-country-icon" alt="Country" />
                        <div className="prediction-popup-main-left-country-value">
                            {prediction.country || 'Not Available'}
                        </div>
                    </div>
                    <div className="prediction-popup-main-left-date">
                        <img src={calendar} className="prediction-popup-main-left-date-icon" alt="Calendar" />
                        <div className="prediction-popup-main-left-date-value">
                            {prediction.event_date ? formatDate(prediction.event_date) : 'Not Available'
                            }
                        </div>
                    </div>
                    <div className="prediction-popup-main-left-location">
                        <img src={location} className="prediction-popup-main-left-location-icon" alt="Location" />
                        <div className="prediction-popup-main-left-location-value">
                            {`${prediction.latitude.toFixed(5)}, ${prediction.longitude.toFixed(5)}`}
                        </div>
                    </div>
                </div>
            </div>
            <div className='prediction-popup-tabs'>
                {['Details', 'Risk', 'Comments'].map((t, index) => (
                    <div
                        key={index}
                        className='prediction-popup-tabs-tab'
                        style={{
                            borderBottom: t === tab ? '2px solid #0080ff' : ''
                        }}
                        onClick={() => setTab(t)}
                    >
                        {t}
                    </div>
                ))}
            </div>
            {stageSwitch(tab)}
        </div>
        :
        <></>
    )
}